import { combineReducers } from 'redux';
import chatListReducer from './chat-list.slice'

const adminChatRootReducer = combineReducers({
    list: chatListReducer,
});

export default adminChatRootReducer;